<template>
	<div class="AccreditTest">
		<el-form :inline="true" :model="formScreen" ref="formScreen">
			<el-form-item label="选择分公司" prop="branchCompany" v-if="[1].includes(type)">
				<el-select v-model="formScreen.branchCompany" placeholder="请选择"
					@change="selectChange($event, 'sonCompany')" value-key="company_id" filterable>
					<el-option v-for="item in branchCompany" :key="item.company_id" :label="item.companyName"
						:value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择子公司" prop="sonCompany" v-if="[2, 1].includes(type)">
				<el-select v-model="formScreen.sonCompany" placeholder="请选择" value-key="rid"
					@change="selectChange($event, 'branchDepartmentList')" filterable>
					<el-option v-for="item in sonCompany" :key="item.company_id" :label="item.companyName"
						:value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择分部门" prop="branchDepartmentValue">
				<el-select v-model="formScreen.branchDepartmentValue" placeholder="请选择"
					@change="selectChange($event, 'groupList')" value-key="rid">
					<el-option v-for="item in branchDepartmentList" :key="item.value" :label="item.departmentName"
						:value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择组" prop="groupValue">
				<el-select v-model="formScreen.groupValue" placeholder="请选择" @change="selectChange($event, 'userList')"
					value-key="rid">
					<el-option v-for="item in groupList" :key="item.value" :label="item.groupName"
						:value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择角色" prop="userValue">
				<el-select v-model="formScreen.userValue" placeholder="请选择" @change="selectChange($event)"
					value-key="rid">
					<el-option v-for="item in userList" :key="item.value" :label="item.roleUserName"
						:value="item"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择活跃状态" prop="active">
				<el-select v-model="active" clearable placeholder="请选择">
					<el-option label="活跃" :value="1"></el-option>
					<el-option label="下架" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="选择店铺状态" prop="state">
				<el-select v-model="state" clearable placeholder="请选择">
					<el-option label="正常" :value="1"></el-option>
					<el-option label="删除" :value="0"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-row>
					<el-input v-model="SearchInp" placeholder="店铺名称、商铺id" style="width:250px;"></el-input>
					<el-button type="primary" @click="Search2" size="mini"
						style="margin-left:10px;padding:7px 15px;">搜索</el-button>
					<el-button type="primary" @click="formScreenReset" size="mini"
						style="padding:7px 15px;">重置</el-button>
				</el-row>
			</el-form-item>
		</el-form>
		<el-button type="primary" @click="AddName = true">新增店铺授权</el-button>
		<div id="amazon-root"></div>
		<div class="ymx_in">
			<el-table :data="tableData" border style="width: 100%;margin-bottom:50px;" v-loading="loadingTable">
				<el-table-column prop="shop_name" label="店铺名称" align="center"></el-table-column>
				<el-table-column prop="sellerId" label="商户ID" align="center"></el-table-column>
				<el-table-column align="center" prop="authorization_time" label="授权时间"></el-table-column>
				<el-table-column prop="active" align="center" width="150" label="活跃状态">
					<template slot-scope="scope">

						<el-switch v-model="scope.row.active" active-color="#13ce66" inactive-color="#ff4949"
							active-text="活跃" inactive-text="下架" :active-value="1" :inactive-value="0"
							@change="handleTableSwitch(scope.row)">
						</el-switch>

					</template>
				</el-table-column>
				<el-table-column align="center" prop="state" label="店铺状态" width="80">
					<template slot-scope="scope">
						<span :class="scope.row.state == 1 ? 'green-text' : 'red-text'">{{ scope.row.state == 1 ? '正常' :
							'删除' }}</span>
					</template>
				</el-table-column>
				<el-table-column align="center" prop="operationName" label="运营部/角色"></el-table-column>
				<el-table-column align="center" prop="purchaseName" label="采购人员"></el-table-column>
				<el-table-column width="200" prop="fenName" label="所属分公司" align="center"
					v-if="type === 1"></el-table-column>
				<el-table-column width="200" prop="ziName" label="所属子公司" align="center"
					v-if="[1, 2].includes(type)"></el-table-column>
				<el-table-column fixed="right" label="操作" width="230" align="center" v-if="type === 3">
					<template slot-scope="scope">
						<div>
							<el-button @click="handleClick(scope.row)" type="text" size="small">更改店铺信息</el-button>
						</div>
						<div>
							<el-button @click="Delete(scope.row)" type="text" size="small">删除</el-button>
						</div>
						<div>
							<el-button @click="distribution(scope.row)" type="text" size="small">分配</el-button>
						</div>
					</template>
				</el-table-column>
			</el-table>

			<div class="page">
				<el-pagination style="margin-right:200px;" @size-change="handleSizeChange"
					@current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[50, 100, 200, 400]"
					:page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
					:total="total"></el-pagination>
			</div>
		</div>

		<el-dialog title="修改相关信息" :visible.sync="EditName" width="30%" style="margin-top:20px;">
			<el-form ref="ruleform" :model="ruleform" label-width="120px" :rules="rules">
				<el-form-item label="店铺名称：" prop="NameStore">
					<el-input v-model="ruleform.NameStore" placeholder="请输入店铺名称"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="EditName = false">取 消</el-button>
				<el-button type="primary" @click="Submit">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="新增SayWeee授权" :visible.sync="AddName" width="30%" style="margin-top:20px;">
			<el-form ref="form" :model="form" label-width="120px" :rules="rules">
				<el-form-item label="店铺名称：" prop="NameStore">
					<el-input v-model="form.NameStore" placeholder="请输入店铺名称"></el-input>
				</el-form-item>
				<el-form-item label="id：" prop="id">
					<el-input v-model="form.id" placeholder="请输入id"></el-input>
				</el-form-item>
				<el-form-item label="secret：" prop="secret">
					<el-input v-model="form.secret" placeholder="请输入secret"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="AddName = false">取 消</el-button>
				<el-button type="primary" @click="SubmitSave">提 交</el-button>
			</div>
		</el-dialog>
		<el-dialog title="店铺分配" :visible.sync="shopDistribution" width="25%" style="margin-top:20px;">
			<el-form class="custom-form" ref="form" label-width="100px" label="left">
				<el-form-item label="选择部门">
					<el-select v-model="value1" @change="choose1" placeholder="请选择">
						<el-option v-for="item1 in this.arr1" :key="item1.value" :label="item1.departmentName"
							:value="item1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择分部门" v-show="isShow">
					<el-select v-model="value2" @change="choose2" placeholder="请选择">
						<el-option v-for="item2 in this.arr2" :key="item2.value" :label="item2.departmentName"
							:value="item2"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择组" v-show="isShow">
					<el-select v-model="value3" @change="choose3" placeholder="请选择">
						<el-option v-for="item3 in this.arr3" :key="item3.value" :label="item3.groupName"
							:value="item3"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="选择员工">
					<el-select v-model="value4" @change="choose4" placeholder="请选择">
						<el-option v-for="item4 in this.arr4" :key="item4.value" :label="item4.roleName"
							:value="item4"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="shopDistribution = false">取消</el-button>
				<el-button type="primary" @click="Submit1" :loading="loadingStatus">分配</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from "../../api/api/api";
import { AmazonPost } from '../../api/api/api'
export default {
	name: 'CoupangAuthorize',
	components: {},
	props: {},
	data() {
		return {
			state: '',
			isDisabled: true,
			active: "",
			EditName: false,
			AddName: false,
			currentPage: 1,
			pagesize: 50,
			size: 50,
			total: 0,
			tableData: [],
			countryCode: '',
			SearchInp: '',
			branchCompany: [],
			sonCompany: [],
			branchDepartmentList: [],
			groupList: [],
			userList: [],
			arr1: '',
			arr2: '',
			arr3: '',
			arr4: '',
			value1: '',
			value2: '',
			value3: '',
			value4: '',
			loadingTable: false,
			shopDistribution: false,
			loadingStatus: false,
			str: '',
			sid: '',
			gid: '',
			rid: '',
			isShow: true,
			formScreen: {
				branchCompany: {},
				sonCompany: {},
				departmentValue: {},
				branchDepartmentValue: {},
				groupValue: {},
				userValue: {},
			},
			sellerId1: '',
			NameValue1: '',
			mwsAuthTokenValue1: '',
			amazon_id1: '',
			developerId: '',
			companyId: '',
			staffId: '',
			System: '',
			type: '',
			form: {
				NameStore: '',
				id: '',
				secret: '',
			},
			bizhongOptions: [],
			ruleform: {
				NameStore: '',
				accessKey: '',
				secretKey: '',
				consumerChannelType: '',
				countryMark: ''
			},
			rules: {
				NameStore: [
					{ required: true, message: '请输入店铺名称', trigger: 'blur' },
				],
				id: [
					{ required: true, message: '请输入id', trigger: 'blur' },
				],
				secret: [
					{ required: true, message: '请输入secret', trigger: 'blur' },
				],
			},
		}
	},
	computed: {},
	watch: {},
	created() {
		this.isDisabled = false
		this.str = JSON.parse(localStorage.getItem('role'))
		if (this.str == null) {
			return false;
		} else {
			this.type = this.str.type
			this.init()
			this.tableList()
		}
		console.log(this.str)
	},
	mounted() {
		// let obj = window.localStorage.getItem('query')
		// console.log(JSON.parse(obj))
	},
	methods: {
		handleTableSwitch(item) {
			const API = Baseurl + 'sellerController/updateSellerInfoActive'
			const paramsData = {
				id: item.id,
				active: item.active
			}
			// paramsData.id = item.id
			// paramsData.priority = item.priority

			ajaxPost(API, paramsData).then(res => {
				const { code, data } = res.data
				if (code === 200) {
					this.$message.success('操作成功')
				} else {
					this.Search2()
					this.$message.error(data)
				}
			})
		},
		
		selectChange(item, type) {
			const { rid, system, company_id: companyId } = item
			companyId && (this.companyId = companyId)
			this.getNextPower(rid, system, type)
			if (type === 'sonCompany') {
				this.formScreen.sonCompany = {}
				this.formScreen.departmentValue = {}
				this.formScreen.groupValue = {}
				this.sonCompany = []
				this.departmentList = []
				this.groupList = []
			} else if (type === 'departmentList') {
				this.formScreen.departmentValue = {}
				this.formScreen.branchDepartmentValue = {}
				this.formScreen.groupValue = {}
				this.departmentList = []
				this.branchDepartmentList = []
				this.groupList = []
			} else if (type === 'branchDepartmentList') {
				this.formScreen.branchDepartmentValue = {}
				this.formScreen.groupValue = {}
				this.branchDepartmentList = []
				this.groupList = []
			} else if (type === 'groupList') {
				this.formScreen.groupValue = {}
				this.formScreen.userValue = {}
				this.groupList = []
				this.userList = []
			} else if (type === 'userList') {
				this.formScreen.userValue = {}
				this.userList = []
			}
			this.staffId = rid
			this.System = system
		},
		Submit1() {
			this.$confirm('是否分配该店铺当前时间之前的所有订单', '提示', {
				confirmButtonText: '是',
				cancelButtonText: '否',
				type: 'warning',
			})
				.then(() => {
					this.isAccept = 1
					this.submitAjax()
				})
				.catch(() => {
					this.isAccept = 0
					this.submitAjax()
				})
		},
		submitAjax() {
			var obj = {
				departmentId: this.departmentId,
				departmentChildId: this.departmentChildId,
				gid: this.gid,
				rid: this.rid,
				sid: this.sid,
				isAccept: this.isAccept,
			}
			// console.log(obj);
			this.loadingStatus = true
			ajaxPost(Baseurl + 'sellerController/allotSeller', obj).then(
				(res) => {
					this.loadingStatus = false
					if (res.data.code == 200) {
						this.$message({
							message: '分配店铺成功',
							type: 'success',
						})
						this.tableList()
						this.shopDistribution = false
					} else {
						this.$message.error(res.data.data)
					}
				}
			)
		},
		choose1(val) {
			this.departmentId = val.did
			// console.log(val)
			this.arr2 = []
			this.arr3 = []
			this.arr4 = []
			this.value2 = ''
			this.value3 = ''
			this.value4 = ''

			if (val.kind === 0) {
				this.isShow = true
				var company_id = {
					dgrId: val.dgrId,
					system: 2,
				}
				ajaxPost(
					Baseurl + 'roleController/selectNextInfoByDgrId',
					company_id
				).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr2 = res.data.data.next
					}
				})
			} else if (val.kind === 1) {
				this.departmentChildId = ''
				this.gid = ''
				this.isShow = false
				var company_id = {
					dgrId: val.dgrId,
					system: 2,
				}
				ajaxPost(
					Baseurl + 'roleController/selectNextInfoByDgrId',
					company_id
				).then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.arr4 = res.data.data.next
					}
				})
			}
		},
		choose2(val) {
			this.departmentChildId = val.did
			// console.log(val)
			this.arr3 = []
			this.arr4 = []
			this.value3 = ''
			this.value4 = ''
			var company_id = {
				dgrId: val.dgrId,
				system: 3,
			}
			ajaxPost(
				Baseurl + 'roleController/selectNextInfoByDgrId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr3 = res.data.data.next
				}
			})
		},
		choose3(val) {
			this.gid = val.gid
			// console.log(val)
			this.arr4 = []
			this.value4 = ''
			var company_id = {
				dgrId: val.dgrId,
				system: 4,
			}
			ajaxPost(
				Baseurl + 'roleController/selectNextInfoByDgrId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr4 = res.data.data.next
				}
			})
		},
		choose4(val) {
			this.rid = val.rid
			// console.log(val)
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`)
			this.size = val
			this.tableList()
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`)
			this.currentPage = val
			this.tableList()
		},
		formScreenReset() {
			this.currentPage = 1
			this.$refs.formScreen.resetFields()
			this.branchCompany = []
			this.sonCompany = []
			this.departmentList = []
			this.branchDepartmentList = []
			this.groupList = []
			this.userList = []
			this.state = '';
			this.SearchInp = ''
			this.staffId = this.str.rid
			this.System = this.str.system
			this.tableList()
			this.init()
		},
		init() {
			const {
				rid,
				system,
				company_id: companyId,
				type: companyType,
			} = this.str
			this.companyId = companyId
			this.staffId = rid
			this.System = system
			let type = ''
			if (companyType === 1) {
				type = 'branchCompany'
			} else if (companyType === 2) {
				type = 'sonCompany'
			} else if (system < 3) {
				type = 'branchDepartmentList'
			} else if (system === 3) {
				type = 'groupList'
			} else {
				return
			}
			// this.tableList(type, companyId, rid, system)
			this.getNextPower(rid, system, type)
		},
		getNextPower(rid, system, type) {
			const API = Baseurl + 'roleController/selectNextInfoByRid'
			const paramsData = { rid, system, companyId: this.companyId, sellerType: 17 }
			ajaxPost(API, paramsData)
				.then((res) => {
					const {
						data: { code, data },
					} = res
					if (code === 200) {
						this[type] = data.next
					}
				})
				.catch((e) => {
					console.log(e)
				})
		},
		tableList() {
			this.loadingTable = true
			const paramsData = {
				isSpapiAuthorize: 0,
				sellerType: 17,
				page: this.currentPage,
				size: this.size,
				company_id: this.companyId,
				rid: this.staffId,
				system: this.System,
				searchString: this.SearchInp,
				active: this.active,
				state: this.state
			}
			ajaxPost(
				Baseurl + 'sellerController/selectSellerListByRid',
				paramsData
			).then((res) => {
				const { code, data } = res.data
				this.loadingTable = false
				if (code === 200) {
					const {
						next = [],
						sellerInfo: { list, total },
					} = data
					// this[type] = next
					this.tableData = list
					this.total = total
					this.tableCountry = []
					for (var i = 0; i < list.length; i++) {
						this.tableCountry.push(list[i].countryMarks)
					}
				}
				// console.log(this.tableData)
			})
		},
		Search2() {
			this.currentPage = 1
			this.tableList()
		},
		Delete(item) {
			// console.log(item)
			this.$confirm('确认删除此条数据', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					var obj = { id: item.id }
					ajaxPost(
						Baseurl + 'sellerController/deleteSellerInfo',
						obj
					).then((res) => {
						if (res.data.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功!',
							})
							this.tableList()
						} else {
							this.$message.error('删除失败')
						}
					})
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除',
					})
				})
		},
		distribution(val) {
			// console.log(val)
			this.sid = val.id
			this.shopDistribution = true
			var company_id = {
				company_id: this.companyId,
				sellerType: 17
			}
			ajaxPost(
				Baseurl + 'roleController/selectDepartmentByCompanyId',
				company_id
			).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.arr1 = res.data.data
				}
			})
		},
		handleClick(item) {
			console.log(item)
			this.EditName = true
			this.sellerId1 = item.sellerId
			this.ruleform.NameStore = item.shop_name
			this.ruleform.accessKey = item.accessKey
			this.ruleform.secretKey = item.secretKey
			if (item.consumerChannelType) {
				this.ruleform.consumerChannelType = item.consumerChannelType
			}
			this.ruleform.countryMark = item.countryMarks[0].countryMark
			this.mwsAuthTokenValue1 = item.mwsAuthToken
			this.amazon_id1 = item.amazon_id
			this.developerId = item.developerId
		},
		SubmitSave() {
			this.$refs['form'].validate((valid) => {
				if (valid) {
					const params = {
						sellerId: this.form.id,
						refreshToken: this.form.secret,
						shopName: this.form.NameStore,
						companyId: this.companyId,
					}
					const API = Baseurl + 'sayweee/addOrUpdateStore';
					ajaxPost(API, params).then((res) => {
						if (res.data.code == 200) {
							// 关闭弹窗
							this.AddName = false;
							this.tableList();
							this.$message({
								type: 'success',
								message: '添加成功!'
							})
						}
					})
				} else {
					return false;
				}
			});
		},
		Submit() {
			this.$refs['ruleform'].validate((valid) => {
				if (valid) {
					var obj = {
						sellerId: this.sellerId1,
						shop_name: this.ruleform.NameStore,
						accessKey: this.ruleform.accessKey,
						secretKey: this.ruleform.secretKey,
						mwsAuthToken: this.mwsAuthTokenValue1,
						consumerChannelType: this.ruleform.consumerChannelType,
						developerId: this.developerId,
						// iossCode: this.iossCode,
					}
					ajaxPost(
						Baseurl + 'sellerController/updateShopNameBySellerId',
						obj
					).then((res) => {
						// console.log(res.data)
						if (res.data.code == 200) {
							this.$message({
								message: '修改店铺信息成功',
								type: 'success',
							})
							this.tableList()
						} else {
							this.$message.error(res.data.data)
						}
					})
					this.EditName = false
				} else {
					return false;
				}
			});

		},
	},
}
</script>

<style lang="scss" scoped>
.AccreditTest {
	width: 98%;

	.el-button {
		padding: 9px 15px;
	}

	.el-table {
		margin-top: 20px;
	}

	.page {
		position: fixed;
		width: 100%;
		bottom: 0;
		background-color: white;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 50px;
	}
}

.green-text {
	color: #67c23a;
}

.red-text {
	color: #f56c6c;
}
</style>
